import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import { generateClinicUrl } from '../../utils/clinicUtils';

const ClinicCard = ({ clinic, onOnboard, showOnboardButton = false, isFromManagement = false }) => {
    const navigate = useNavigate();

    const handleViewDetails = () => {
        const context = isFromManagement ? 'manage' : 'onboard';
        const url = generateClinicUrl(clinic.name, clinic.clinicId, context);
        
        navigate(url, {
            state: { 
                fromManagement: isFromManagement,
                fromPage: isFromManagement ? 'manage' : 'onboard'
            }
        });
    };

    return (
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
            {/* Clinic Image */}
            <div className="relative h-40 sm:h-48">
                <img
                    src={clinic.thumbnailUrls?.[0] || '/placeholder-clinic.jpg'}
                    alt={clinic.name}
                    className="w-full h-full object-cover"
                />
                {parseFloat(clinic.averageRating) > 0 ? (
                    <div className="absolute top-2 right-2 bg-white px-2 py-1 rounded-full text-sm font-medium text-gray-900">
                        ⭐ {parseFloat(clinic.averageRating).toFixed(1)}
                    </div>
                ) : (
                    <div className="absolute top-2 right-2 bg-white px-2 py-1 rounded-full text-sm font-medium text-gray-900">
                        New
                    </div>
                )}
            </div>

            {/* Clinic Info */}
            <div className="p-3 sm:p-4">
                <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">{clinic.name}</h3>
                <p className="text-gray-600 text-sm mb-2">{clinic.address}</p>
                <div className="flex flex-wrap items-center text-sm text-gray-500 mb-3 sm:mb-4">
                    <span>{clinic.cityName}, {clinic.stateName}</span>
                    {clinic.areaName && (
                        <>
                            <span className="mx-2">•</span>
                            <span>{clinic.areaName}</span>
                        </>
                    )}
                </div>

                {/* Experience */}
                {clinic.totalExperience && (
                    <div className="text-sm text-gray-600 mb-3 sm:mb-4">
                        Experience: {clinic.totalExperience} years
                    </div>
                )}

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
                    <Button
                        onClick={handleViewDetails}
                        variant="secondary"
                        className="flex-1"
                    >
                        View Details
                    </Button>
                    {showOnboardButton && (
                        <Button
                            onClick={() => onOnboard(clinic.clinicId)}
                            variant="primary"
                            className="flex-1"
                        >
                            Onboard
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ClinicCard; 